import { z } from 'zod'
import { dateValueSchema } from '~library/models'

export const invitationByEmailSchema = z.object({
  /** 邀請紀錄主表Id */
  id: z.string(),
  /** 寄送者 */
  sender: z.string(),
  /** 寄送者姓名[英文] */
  englishName: z.string(),
  /** 寄送者姓名 */
  name: z.string(),
  /** 寄送時間 */
  sendTime: dateValueSchema,
  /** 信箱 */
  email: z.string()
})

export interface InvitationByEmail
  extends z.infer<typeof invitationByEmailSchema> {}
